import React from "react";
import EstateCard from "./EstateCard";

type LikedModalProps = {
  likedData: any[];
  onSelect: (item: any) => void;
  formatKoreanMoney: (amount: any) => string;
  onClose: () => void;
};

const LikedModal: React.FC<LikedModalProps> = ({
  likedData,
  onSelect,
  formatKoreanMoney,
  onClose,
}) => (
  <div className="fixed left-1/2 bottom-10 -translate-x-1/2 z-40 bg-white rounded-xl shadow-lg min-w-[340px] max-w-[600px] max-h-80 overflow-y-auto p-5 flex gap-4">
    <div className="absolute top-2 right-3">
      <button
        onClick={onClose}
        className="text-xl text-gray-400 hover:text-gray-600"
      >
        ×
      </button>
    </div>
    {likedData.length === 0 ? (
      <div className="text-gray-400">좋아요한 매물이 없습니다.</div>
    ) : (
      likedData.map((item) => (
        <EstateCard
          key={item.idx}
          item={item}
          onClick={() => onSelect(item)}
          formatKoreanMoney={formatKoreanMoney}
        />
      ))
    )}
  </div>
);

export default LikedModal;
